import { render, staticRenderFns } from "./shipment-send-icon.vue?vue&type=template&id=559b980d"
import script from "./shipment-send-icon.vue?vue&type=script&lang=js"
export * from "./shipment-send-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports